import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { ArrayUtil, ObjectUtil, StringUtil } from 'src/utils';

interface LocationAccessListItemDTO {
  id: string;
  partner: string;
  code: string;
  location: string;
  disabled: boolean;
  comment: string;
}
const LocationAccessListItemDTO = {
  create: (initValues?: Partial<LocationAccessListItemDTO>): LocationAccessListItemDTO => {
    const defaults: LocationAccessListItemDTO = {
      id: '',
      partner: '',
      code: '',
      location: '',
      disabled: false,
      comment: '',
    };
    const fixedInitValues: Partial<LocationAccessListItemDTO> = initValues != null
      ? {
        id: StringUtil.IsNullOrEmpty(initValues.id) ? uuidv4() : initValues.id,
      }
      : {};
    return { ...defaults, ...initValues, ...fixedInitValues };
  },
};

export default LocationAccessListItemDTO;
